<template>
  <div class="breadcumnd-banner">
    <div class="container-fluid">
      <div class="breadcumnd-content">
        <h1>{{ pageTitle }}</h1>
        <ul>
          <li v-for="(link, index) in links" :key="index">
            <!-- If the link has a URL, make it clickable -->
            <template v-if="link.url">
              <router-link :to="link.url">{{ link.name }}</router-link>
            </template>
            <!-- If no URL, display plain text -->
            <template v-else>
              {{ link.name }}
            </template>
            <!-- Add an arrow if it's not the last link -->
            <i
              v-if="index !== links.length - 1"
              :class="[
                'fas mx-2',
                isRtlLayout ? 'fa-arrow-left-long' : 'fa-arrow-right-long',
              ]"
            >
            </i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BreadcrumbBanner",
  inject: ["isRtlLayout"],
  props: {
    pageTitle: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>
